import React, { useEffect } from 'react';
import {Button} from "antd";

export const CountDown = ({ action }) => {
    const [counter, setCounter] = React.useState(30);

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    const handleAction = () => {
        setCounter(30);
        action()
    }

    if (counter === 0) {
        return (
            <Button
                style={{ marginBottom: '50px', width: '192px', color: '#5552EA' }}
                onClick={handleAction}
                type="link"
            >
                Կրկին ուղարկել կոդ
            </Button>
        )
    }

    return (
        <div style={{ paddingBottom: '50px', color: '#5552EA' }}>
            Նոր կոդը հասանելի կլինի 00:{counter < 10 ? `0${counter}` : counter}
        </div>
    );
}

CountDown.propTypes = {};